import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaControleInternoRecursoRecebidoInicio: [],
    buscaControleInternoRecursoRecebidoSucesso: ['controleInternoRecursoRecebido'],
    buscaControleInternoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaControleInternoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaControleInternoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarControleInterno(filtro)
            .then(response => dispatch(Creators.buscaControleInternoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaControleInternoRecursoRecebidoErro(error)))
    }
}

const buscaControleInternoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaControleInternoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaControleInternoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.controleInternoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_RECEBIDO_INICIO]: buscaControleInternoRecursoRecebidoInicio,
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_RECEBIDO_ERRO]: buscaControleInternoRecursoRecebidoErro,
    [Types.BUSCA_CONTROLE_INTERNO_RECURSO_RECEBIDO_SUCESSO]: buscaControleInternoRecursoRecebidoSucesso,
})
